import { useState } from "react";
import clsx from "clsx";
import axios from "axios";
import { toast } from "react-toastify";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/layouts/mobile.css";
import opacity from "react-element-popper/animations/opacity";
import dayjs from "dayjs";
import moment from "moment-timezone";

const CreateVoucherModalForm = ({
  setOpenCreateVoucherModal,
  fetchVouchers
}) => {
  const [loading, setLoading] = useState(false);
  const [requesterName, setRequesterName] = useState("");
  const [prefix, setPrefix] = useState("");
  const [amount, setAmount] = useState("");
  const [limit, setLimit] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const cancel = () => {
    setLoading(false);
    setRequesterName('');
    setAmount('');
    setPrefix('');
    setStartDate('');
    setEndDate('');
    setLimit('');
    setOpenCreateVoucherModal(false);
  }

  const isDisabled = () => {
    let result = false
    if (!amount || !startDate || !endDate || !limit || loading) {
      result = true
    }
    return result
  }

  const addCreateVoucher = (e) => {
    setLoading(true);
    e.preventDefault();
    axios.post(`${process.env.REACT_APP_API_V3_URL}/wallets/redemption-codes`, {
      ...(prefix && { prefix }),
      amount: +amount * 100,
      limit: +limit,
      start_date: dayjs(startDate).format('YYYY-MM-DD'),
      end_date: dayjs(endDate).format('YYYY-MM-DD'),
      ...(requesterName && { requested_by: requesterName })
    }).then(() => {
      toast.success("New Voucher Created Successfully")
      fetchVouchers();
      cancel();
    }).catch((err) => {
      if (err && err.response && err.response?.data && err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Technical Error, Please Try Again");
      }
      setLoading(false);
    })
  }


  return (
    <>
      {/* begin::Scroll */}
      <form className="form" id="kt_modal_add_user_form" autoComplete="off"
        onSubmit={addCreateVoucher} method="post" action="">
        <div
          className="d-flex flex-column scroll-y me-n7 pe-7"
          id="kt_modal_add_user_scroll"
          data-kt-scroll="true"
          data-kt-scroll-activate="{default: false, lg: true}"
          data-kt-scroll-max-height="auto"
          data-kt-scroll-dependencies="#kt_modal_add_user_header"
          data-kt-scroll-wrappers="#kt_modal_add_user_scroll"
          data-kt-scroll-offset="300px"
        >
          <div className="fv-row mb-3">
            <label className="fw-bold fs-6 mb-2">Voucher Prefix (Optional)</label>
            <input
              placeholder="Enter Prefix Eg: TPC, VCH, etc"
              className={clsx(
                "form-control form-control-solid mb-3 mb-lg-0"
              )}
              type="text"
              name="prefix"
              value={prefix}
              onChange={(e) => {
                setPrefix(e.target.value.slice(0, 6));
              }}
            />
          </div>
          <div className="fv-row mb-3">
            <label className="required fw-bold fs-6 mb-2">Voucher Amount</label>
            <input
              placeholder="Enter Voucher Amount"
              className={clsx(
                "form-control form-control-solid mb-3 mb-lg-0"
              )}
              type="text"
              onWheel={(e) => e.target.blur()}
              name="amount"
              value={amount}
              min={1}
              onChange={(e) => {
                const re = /^[0-9]*$/;
                if (!re.test(e.target.value)) {
                  setAmount("");
                } else {
                  if (+e.target.value >= +1 && +e.target.value <= +9999 || e.target.value === "") {
                    setAmount(e.target.value);
                  }
                }
              }}
            />
          </div>
          <div className="fv-row mb-3">
            <label className="required fw-bold fs-6 mb-2">Total Vouchers</label>
            <div style={{ position: "relative" }}>
              <input
                placeholder="Enter Total Vouchers"
                type="text"
                name="limit"
                className={clsx("form-control form-control-solid mb-3 mb-lg-0")}
                value={limit || ""}
                onChange={(e) => {
                  const re = /^[0-9]*$/
                  if (!re.test(e.target.value)) {
                    return;
                  } else {
                    setLimit(e.target.value)
                  }
                }}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="fv-row mb-3">
            <label className="required fw-bold fs-6 mb-2">Start Date</label>
            <DatePicker
              style={{
                width: "100%",
                boxSizing: "border-box",
                borderRadius: "8px",
                padding: "0.775rem 1rem",
                fontSize: "1.1rem",
                fontWeight: "500",
                lineHeight: "1.5",
                backgroundColor: "#f9f9f9",
                border: "1px solid #f9f9f9",
                color: "#5e6278",
                height: "auto"
              }}
              containerStyle={{
                width: "100%"
              }}
              className="rmdp-mobile custom-calendar"
              arrow={false}
              value={startDate}
              onChange={setStartDate}
              format="dddd MMM DD,YYYY"
              fixMainPosition={true}
              minDate={moment().utc().toDate()}
              animations={[opacity()]}
              placeholder="Select Start Date"
              weekDays={["S", "M", "T", "W", "T", "F", "S"]}
              scrollSensitive={false}
              hideOnScroll={false}
            />
          </div>
          <div className="fv-row mb-3">
            <label className="required fw-bold fs-6 mb-2">End Date</label>
            <DatePicker
              style={{
                width: "100%",
                boxSizing: "border-box",
                borderRadius: "8px",
                padding: "0.775rem 1rem",
                fontSize: "1.1rem",
                fontWeight: "500",
                lineHeight: "1.5",
                backgroundColor: "#f9f9f9",
                border: "1px solid #f9f9f9",
                color: "#5e6278",
                height: "auto"
              }}
              containerStyle={{
                width: "100%"
              }}
              className="rmdp-mobile custom-calendar"
              arrow={false}
              value={endDate}
              onChange={setEndDate}
              format="dddd MMM DD,YYYY"
              fixMainPosition={true}
              minDate={startDate ?
                dayjs(startDate).add(1, "day").toDate()
                : moment().utc().toDate()}
              animations={[opacity()]}
              placeholder="Select End Date"
              weekDays={["S", "M", "T", "W", "T", "F", "S"]}
              scrollSensitive={false}
              hideOnScroll={false}
            />
          </div>
          <div className="fv-row mb-3">
            <label className="fw-bold fs-6 mb-2">Requester Name (Optional)</label>
            <input
              placeholder="Enter Requester Name"
              className={clsx(
                "form-control form-control-solid mb-3 mb-lg-0"
              )}
              type="text"
              name="requestor"
              value={requesterName}
              onChange={(e) => {
                setRequesterName(e.target.value);
              }}
            />
          </div>
        </div>
        <div className="text-center pt-10">
          <button
            type="reset"
            onClick={() => cancel()}
            className="btn btn-light mx-3"
            data-kt-users-modal-action="cancel"
          >
            Discard
          </button>
          <button
            type="submit"
            className="btn btn-main text-white"
            data-kt-users-modal-action="submit"
            disabled={isDisabled()}
          >
            <span className="indicator-label">Submit</span>
          </button>
        </div>
      </form >
    </>
  );
};

export { CreateVoucherModalForm };
